module.exports = __webpack_public_path__ + "img/logistics.364e391c.svg";